

import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";
import * as tableActions from '../../../store/actions/table';
import Button from "react-bootstrap/Button";
import { ArrowBack } from "react-ionicons";
import JudgeConfig from "./JudgeConfig";

class Judges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []
        }
    }

    componentDidMount(props) {

    }

    componentDidUpdate(props, state) {

    }

    render() {
        //console.log
        return (
            <div className={'page-container'}>
                <div className={'page-header'} style={{marginBottom: '0px'}}>
                    <Row>
                        <Col>
                            <h1>

                                    <Button variant={"flat btn-round"} onClick={e => {

                                        this.props.history.push(`/app/event-dashboard/${this.props.match.params.id}`);
                                    }}>
                                        <ArrowBack />
                                    </Button>


                                Judges</h1>
                        </Col>
                        <Col className={"text-right"}>
                            {this.props.events.event.judges ? this.props.events.event.judges.length === 0 ?
                                <div>
                                    <Button variant={"secondary"} onClick={e => {
                                        this.props.history.push(`/app/event-dashboard/${this.props.match.params.id}/judges/add`)
                                    }}>Add Judges</Button>
                                </div>
                                :
                                <div>
                                    <Button variant={"secondary"} onClick={e => {
                                        this.props.history.push(`/app/event-dashboard/${this.props.match.params.id}/judges/add`)
                                    }}>Add/Remove Judges</Button>
                                </div>
                                : null
                            }
                        </Col>
                    </Row>
                </div>
                <div className={"divider"} />




                {this.props.events.event.judges ?
                    this.props.events.event.judges.length > 0 ?
                        <JudgeConfig />
                        : null
                : null}



            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    events: state.events
});

const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(Judges));

class JudgesContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default JudgesContainer;